module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/FinishZero-22a5366e36580db6f35fdf72bec145d1.png";